import React from 'react';
import { EcoClub3Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub3Class2026/>;
};

export default AccountGeneralPage;